// extracted by mini-css-extract-plugin
export var activeTab = "OrganizationSettings-module--activeTab--uf8r4";
export var container = "OrganizationSettings-module--container--6CUgj";
export var content = "OrganizationSettings-module--content--9eZGu";
export var tabContentSubTitle = "OrganizationSettings-module--tabContentSubTitle--b6g+r";
export var tabContentTitle = "OrganizationSettings-module--tabContentTitle--DajZI";
export var tabs = "OrganizationSettings-module--tabs--50mKn";